import React from 'react'

import MoreIcon from '../Icons/MoreIcon'

import ButtonMenu from '../../../../../molecules/ButtonMenu2'
import Radio from '../../../../../atoms/Radio'

import { useEnterMode } from '../../../../../../providers/EnterModeProvider'
import useStyles from './styles'

const NORMAL_SEND = 'true'
const SHIFT_SEND = 'false'
const ENTER_OPTIONS = {
  [NORMAL_SEND]: ['Press Enter to Send', 'Pressing Enter will send message'],
  [SHIFT_SEND]: ['Click Send', 'Clicking Send will send message']
}

const EnterMenu = () => {
  const { sendOnEnter, setSendOnEnter } = useEnterMode()

  const classes = useStyles()

  return (
    <ButtonMenu
      options={Object.keys(ENTER_OPTIONS)}
      onSelect={setSendOnEnter}
      selected={`${sendOnEnter}`}
      renderOption={id => {
        const [title, subtitle] = ENTER_OPTIONS[id]

        return (
          <div className={classes.option}>
            <Radio
              checked={`${sendOnEnter}` === id}
              className={classes.radio}
            />

            <div>
              <div className={classes.title}>{title}</div>

              <div className={classes.subTitle}>{subtitle}</div>
            </div>
          </div>
        )
      }}
      className={classes.root}
      menuProps={{
        anchorOrigin: { horizontal: 'right', vertical: -7 },
        transformOrigin: { horizontal: 'right', vertical: 'bottom' },
        autoFocus: false
      }}
      classes={{
        paper: classes.paper,
        list: classes.list,
        item: classes.item
      }}
    >
      <MoreIcon />
    </ButtonMenu>
  )
}

export default EnterMenu
